// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"961b7d8e","594":"972002e6","808":"a5e5a7c9"}[chunkId] + ".chunk.css";
};